import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '919535781848';
const DEFAULT_MESSAGE = "Hi, I'm interested in AirVia flight subscriptions. Please share details.";

export default function WhatsAppButton() {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-chat-btn"
      className="fixed bottom-24 right-5 z-[9998] flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
}
